import { flow, get, getOr } from 'lodash/fp';
import { createSelector, createStructuredSelector } from 'reselect';
import { getAds } from 'helpers/ad/getAds';
import formFromMeta from 'components/searchAds/mappers/formFromMeta';

const getRequest = get(['request']);
const getResultsAmount = get(['result', 'response', 'hits', 'total']);
const getFormFromMeta = flow(getRequest, get(['body', 'meta']), formFromMeta());
const getPageSize = flow(getFormFromMeta, get(['pageSize']), Number);
const getCurrentPage = flow(getFormFromMeta, getOr('1', ['page']));
const getLikeCount = get(['result', 'likeCount']);
const getDislikeCount = get(['result', 'dislikeCount']);

const getPageNumber = createSelector(
  getResultsAmount,
  getPageSize,
  (resultsAmount, pageSize) => Math.ceil(resultsAmount / pageSize),
);

const getPagination = createStructuredSelector({
  currentPage: getCurrentPage,
  pageNumber: getPageNumber,
  pageSize: getPageSize,
  resultsAmount: getResultsAmount,
});

export default createStructuredSelector({
  items: getAds,
  pagination: getPagination,
  likeCount: getLikeCount,
  dislikeCount: getDislikeCount,
});
